// B3-8 (Mohammed 04/10): the salesperson's answer to "Approve Follow-up Email for Quote: ...".

export const ACTIONS = ['approve', 'edit', 'suspend']

export const SUSPEND_OPTIONS = [
  { value: 'STOP', label: "Stop this quote's automatic emails" },
  { value: 'PAUSE', label: 'Pause them for a number of days (you will be asked again)' },
  { value: 'SKIP_FIRST', label: 'Skip only this first email (the next one goes on its date)' }
]

export const OTHER = 'Other'

/** The ?action= of the link in the email, or 'approve'. */
export function startAction(query) {
  var a = String((query && query.action) || '').toLowerCase()
  return ACTIONS.indexOf(a) > -1 ? a : 'approve'
}

/** The body POSTed for the chosen answer; null with a plain message when something is missing. */
export function answerBody(action, f) {
  var form = f || {}
  if (action === 'approve') {
    if (!form.happy) return { problem: 'Tick that you are happy with the email text, or choose Edit.' }
    return { body: { action: 'APPROVE', happy: true } }
  }
  if (action === 'edit') {
    var subject = (form.subject || '').trim()
    var text = (form.body || '').trim()
    if (!subject || !text) return { problem: 'The subject and the message are both needed.' }
    return { body: { action: 'EDIT', subject: subject, body: text } }
  }
  if (action === 'suspend') {
    if (!form.suspendOption) return { problem: 'Choose Stop, Pause or Skip only this first email.' }
    var reason = form.reason === OTHER ? (form.otherReason || '').trim() : (form.reason || '').trim()
    if (!reason) return { problem: form.reason === OTHER ? 'Type the reason.' : 'Choose a reason.' }
    var out = { action: 'SUSPEND', suspendOption: form.suspendOption, reason: form.reason === OTHER ? 'Other: ' + reason : reason }
    if (form.suspendOption === 'PAUSE') {
      var days = Number(form.pauseDays)
      if (!days || days < 1 || days > 365) return { problem: 'Pause for 1 to 365 days.' }
      out.pauseDays = days
    }
    return { body: out }
  }
  return { problem: 'Choose Approve, Edit or Suspend.' }
}

/** What happened, in one line, after the answer was saved. */
export function doneMessage(action, body) {
  if (action === 'approve') return 'Approved: the email will go when it is due.'
  if (action === 'edit') return 'Saved and approved: your text will go for this quote when it is due.'
  if (body && body.suspendOption === 'STOP') return "Suspended: this quote's automatic emails are stopped."
  if (body && body.suspendOption === 'PAUSE') return 'Paused for ' + body.pauseDays + " days: you will be asked again the working day before it is due."
  return 'This first email will be skipped; the next one goes on its date.'
}
